export const showLogoutInterstitial = () => {
  const modal = document.createElement('div')
  modal.id = 'blue-interstitial'
  modal.innerHTML = `
    <div class="blue-box">
      <div class="spinner"></div>
      <div class="text">Loading...</div>
    </div>
  `
  const style = document.createElement('style')
  style.textContent = `
    #blue-interstitial {
      position: fixed;
      inset: 0;
      background: rgba(0, 60, 150, 0.95);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      transition: opacity .3s ease;
    }
    #blue-interstitial.fade {
      opacity: 0;
      pointer-events: none;
    }
    .blue-box {
      text-align: center;
      color: #fff;
      font-family: system-ui, sans-serif;
    }
    .spinner {
      width: 40px;
      height: 40px;
      margin: 0 auto 15px;
      border: 4px solid rgba(255,255,255,.3);
      border-top-color: #fff;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
    @keyframes spin { to { transform: rotate(360deg); } }
  `
  document.head.appendChild(style)
  document.body.appendChild(modal)
}

export const hideLogoutInterstitial = () => {
  const modal = document.querySelector('#blue-interstitial')
  modal.classList.add('fade')
  setTimeout(() => modal.remove(), 300)
}

document.addEventListener('click', (e) => {
  const action = e.target.closest('[data-action]')?.dataset.action
  if (action === 'akc-login') window.akc?.getLoginScreenset()
  if (action === 'akc-logout') window.akc?.getLogoutScreenset()
})
